import React, { PureComponent } from 'react';
import PageHeaderLayout from '../../layouts/PageHeaderLayout';

class UBshopVendor extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.refresh();
  }

  render() {
    return (
      <PageHeaderLayout />
    );
  }
}

UBshopVendor.propTypes = {
};

UBshopVendor.defaultProps = {
};

export default (UBshopVendor);




// WEBPACK FOOTER //
// ./src/containers/Home/index.js